export default "__VITE_ASSET__pxYOg6B___"